(() => {

  if (!window.location.href.includes('a/gc/gift-card')) return;

  document.addEventListener('gcp-page-loaded', function() {
    const currentPage = window.GCPSDK.page.get();
    if (!currentPage || currentPage.step !== "gift_card") return;

    const descriptionEl = document.querySelector(".gc__form_help");
    const targetEl = document.querySelector(".gc__message_details_div");
    if (!descriptionEl || !targetEl) return;

    const clone = descriptionEl.cloneNode(true);
    clone.style.padding = "0";
    clone.style.borderBottom = "none";

    targetEl.parentNode.insertBefore(clone, targetEl);
    descriptionEl.style.display = "none";

  });

})();
